import React, { FunctionComponent } from "react";

type Props = {
  message: string;
};
const FormError: FunctionComponent<Props> = ({ message }) => {
  if (!message) return <></>;

  return (
    <div className="mb-2 rounded bg-red-500 p-2">
      <span className="text-md ml-1 text-white">{message}</span>
    </div>
  );
};

export default FormError;
